<div class="icones-container">
  <div class="connection-line"></div>

  <div
    class="icone-container"
    (mouseenter)="alternarIconePreenchido(iconeAtivo.ANDARILHO)"
    (mouseleave)="alternarIconePreenchido(iconeAtivo.ANDARILHO)"
    routerLink="{{
      caminhoAtual
    }}/acesso-oferta-educacional/diagnostico-matricula"
    (click)="iconeClicado(iconeAtivo.ANDARILHO)"
  >
    <app-icone-andarilho
      class="icone"
      [preenchido]="iconeAndarilhoPreenchido"
      [bloqueado]="iconeAndarilhoBloqueado"
    ></app-icone-andarilho>

    <span
      style="color: #e63d25"
      [ngClass]="{
        'texto-icone': !iconeAndarilhoSubtituloBold,
        'texto-icone-bold': iconeAndarilhoSubtituloBold
      }"
    >
      Acesso e oferta educacional
    </span>
  </div>

  <div
    class="icone-container"
    (mouseenter)="alternarIconePreenchido(iconeAtivo.QUALIDADE)"
    (mouseleave)="alternarIconePreenchido(iconeAtivo.QUALIDADE)"
    routerLink="{{ caminhoAtual }}/condicao-qualidade/numero-de-dias-letivos"
    (click)="iconeClicado(iconeAtivo.QUALIDADE)"
  >
    <app-icone-qualidade
      class="icone"
      [preenchido]="iconeQualidadePreenchido"
      [bloqueado]="iconeQualidadeBloqueado"
    ></app-icone-qualidade>

    <span
      [ngClass]="{
        'texto-icone': !iconeQualidadeSubtituloBold,
        'texto-icone-bold': iconeQualidadeSubtituloBold
      }"
    >
      Condições de qualidade
    </span>
  </div>

  <div
    class="icone-container"
    (mouseenter)="alternarIconePreenchido(iconeAtivo.MOEDAS)"
    (mouseleave)="alternarIconePreenchido(iconeAtivo.MOEDAS)"
    routerLink="{{ caminhoAtual }}/condicao-qualidade/direitos-obrigacoes-trabalhistas"
    (click)="iconeClicado(iconeAtivo.MOEDAS)"
  >
    <app-icone-moedas
      class="icone"
      [preenchido]="iconeMoedasPreenchido"
      [bloqueado]="iconeMoedasBloqueado"
    ></app-icone-moedas>

    <span
      [ngClass]="{
        'texto-icone': !iconesMoedasSubtituloBold,
        'texto-icone-bold': iconesMoedasSubtituloBold
      }"
    >
      Preços, encargos e adicionais
    </span>
  </div>

  <div
    class="icone-container"
    (mouseenter)="alternarIconePreenchido(iconeAtivo.FINANCEIRO)"
    (mouseleave)="alternarIconePreenchido(iconeAtivo.FINANCEIRO)"
    routerLink="{{ novoResultado }}"
    (click)="iconeClicado(iconeAtivo.FINANCEIRO)"
  >
    <app-icone-financeiro
      class="icone"
      [preenchido]="iconeFinanceiroPreenchido"
      [bloqueado]="iconeFinanceiroBloqueado"
    ></app-icone-financeiro>

    <span
      class="texto-icone"
      [ngClass]="{
        'texto-icone': !iconeFinanceiroSubtituloBold,
        'texto-icone-bold': iconeFinanceiroSubtituloBold
      }"
    >
      Novo resultado
    </span>
  </div>
</div>
